/* eslint-disable */
export default {
  download: 'Herunterladen',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
